/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { TrainVariantOptions, TrainStyles } from './themes/TrainStyles.css';
import { classNames } from '../utils/UNSAFE_classNames';
import { TrainRedwoodTheme } from './themes/redwood/TrainTheme';

interface ConnectorProps {
  /**
   * Determines if the adjacent steps should be connected.
   */
  isConnected: boolean;
}

export const Connector = ({ isConnected }: ConnectorProps) => {
  const { styles, variantClasses } = useComponentTheme<TrainVariantOptions, TrainStyles>(
    TrainRedwoodTheme,
    {
      connectorConnected: isConnected ? 'isConnected' : 'notConnected'
    }
  );

  return <span class={classNames([styles.connectorBaseStyle, variantClasses])}></span>;
};
